"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VIcon_vue_1 = __importDefault(require("./VIcon.vue"));
var Window_vue_1 = __importDefault(require("../Window.vue"));
var vClickOutside = require("v-click-outside");
var __ = window.$lang;
exports.default = vue_1.default.extend({
    name: "v-modal",
    components: {
        VIcon: VIcon_vue_1.default,
        Window: Window_vue_1.default
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String
        },
        description: {
            type: String
        },
        icon: {
            type: String
        },
        dialogClass: {
            type: String,
            default: ""
        }
    },
    methods: {
        onClickOutside: function () {
            this.$emit("close");
        },
        isSlotUsed: function (slotName) {
            return this.$slots[slotName];
        }
    }
});
